import styled from 'helpers/styles';
import {css} from 'styled-components';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledToolbarWrapper = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--toolbar-wrapper-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--toolbar-wrapper-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--toolbar-wrapper-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px',
      '--toolbar-wrapper-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: fit-content;
  min-width: 100%;

  ${props => props.$dialog ? css`
    width: 100%; 
  ` : css``}
  
  > .ToolbarWrapper {
    &-toolbar {
      top: ${props => props.$css.$var('--toolbar-wrapper-bounds-top')};
      left: ${props => props.$css.$var('--toolbar-wrapper-bounds-left')};
      padding: 0 !important;
      scroll-margin: 0;
      overflow: hidden;

      ${props => !props.$dialog ? css`
        position: fixed;
        width: calc(100vw - (${props.$css.$var('--toolbar-wrapper-bounds-left')} + ${props.$css.$var('--toolbar-wrapper-bounds-right')}));
      ` : css`
        position: absolute;
        width: 100%;
      `}
    }
    
    &-content {
      height: 100%;
      width: fit-content;
      min-width: 100%;
      align-self: center;

      ${props => props.$dialog ? css`
        flex-grow: 1;
        height: 1px; 
        width: 100%
      ` : css``}
    }
  }

  &.ToolbarWrapper-anchor-bottom {
    > .ToolbarWrapper {
      &-toolbar {
        flex-direction: column-reverse;
        
        top: unset;
        bottom: ${props => props.$css.$var('--toolbar-wrapper-bounds-bottom')};
        
        border-bottom: unset;
        border-top: 1px solid ${props => props.theme.property('palette.divider')};
      }
    }
  }

  &.ToolbarWrapper-sticky {
    > .ToolbarWrapper {
      &-toolbar {
        position: sticky;
        top: ${props => props.$css.$var('--toolbar-wrapper-bounds-top')};
      }
    }

    &.ToolbarWrapper-anchor-bottom {
      > .ToolbarWrapper {
        &-toolbar {
          top: unset;
          bottom: ${props => props.$css.$var('--toolbar-wrapper-bounds-bottom')};
        }
      }
    }
  }

  &.ToolbarWrapper-inset {
    > .ToolbarWrapper {
      &-toolbar {
        position: sticky;
        z-index: 0 !important;
        top: unset;
        bottom: unset;
        scroll-margin: inherit;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledToolbarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledToolbarWrapper;
